// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import CalendarOutlinedSvg from "@ant-design/icons-svg/lib/asn/CalendarOutlined";
import AntdIcon from "../components/AntdIcon";
const CalendarOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: CalendarOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    CalendarOutlined.displayName = "CalendarOutlined";
}
export default /*#__PURE__*/ React.forwardRef(CalendarOutlined);
